module.exports = __webpack_public_path__ + "static/img/main11.7a78b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/main11.png
// module id = PvA2
// module chunks = 1